import {
  en_apacTranslations,
  en_defaultTranslations,
  en_hsbcSgTranslations,
  en_hsbcInTranslations,
  enGB_defaultTranslations,
  enGB_hsbcSgTranslations,
  enGB_hsbcInTranslations,
  enGB_apacTranslations,
} from "@hopper-b2b/i18n";
import { TranslationLanguage } from "@hopper-b2b/types";
import { merge } from "lodash-es";

/** Some configurations don't need a review from translations team
 * If you want to override any of them, add them as an attribute in this object
 */
const enGBTranslations = merge(
  enGB_defaultTranslations,
  enGB_apacTranslations,
  enGB_hsbcSgTranslations,
  enGB_hsbcInTranslations
);
const enUSTranslations = merge(
  en_defaultTranslations,
  en_apacTranslations,
  en_hsbcSgTranslations,
  en_hsbcInTranslations
);

const translation = {
  [TranslationLanguage.en]: enUSTranslations,
  [TranslationLanguage["en-IN"]]: enGBTranslations,
  [TranslationLanguage["en-GB"]]: enGBTranslations,
  [TranslationLanguage["en-US"]]: enUSTranslations,
};

export default translation;
